var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linkTypePickerPanel",attrs:{"role":"listbox","aria-label":"选择资源类型"}},[_c('generic-resource-type-picker',{attrs:{"selected-asset-type":_vm.value,"type-options":_vm.typeOptions},on:{"select":_vm.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }